import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rtAdminFilter',
  standalone: true,
})
export class AdminFilterPipe implements PipeTransform {
  public transform<T extends { firstName: string; lastName: string }>(
    admins: T[],
    query: string,
  ): T[] {
    if (query && query.length > 0) {
      return (
        admins &&
        admins.filter(admin => {
          const name = `${admin.firstName.toLowerCase()} ${admin.lastName.toLowerCase()}`;
          return name.indexOf(query.toLowerCase()) !== -1;
        })
      );
    }
    return admins;
  }
}
